
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";

import ProtectedRoute from "./components/ProtectedRoute";
import DashboardLayout from "./Layout/DashboardLayout";
import Reporting from "./pages/Reporting";
import Dashboard from "./pages/Dashboard";
import Unbind from "./pages/Unbind";
import OnboardMerchantPage from "./pages/OnboardMerchantPage";
import CreateTerminalPage from "./pages/CreateTerminalPage";
import Merchants from "./pages/merchants";
import Terminals from "./pages/terminals";
import Users from "./pages/users";
import CreateUser from "./pages/CreateUsers";
import Operations from "./pages/Operations";
import Inventory from "./pages/Inventory";
import HardPOS from "./pages/HardPOS";

function App() {
  return (
    <Routes>
      {/* Login Page */}
      <Route path="/" element={<Login />} />

      {/* Protected Dashboard Layout */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        {/* Nested pages */}
        <Route index element={<Dashboard />} />
        <Route path="reporting" element={<Reporting />} />
         <Route path="unbind" element={<Unbind />} />
         <Route path="operations" element={<Operations />} />
         <Route path="merchant" element={<OnboardMerchantPage />} />
         <Route path="terminal" element={<CreateTerminalPage />} />
         <Route path="user" element={<CreateUser />} />
         <Route path="hardpos" element={<HardPOS />} />
         <Route path="inventory" element={<Inventory />} />
         <Route path="merchantslist" element={<Merchants />} />
         <Route path="terminalslist" element={<Terminals />} />
         <Route path="userslist" element={<Users />} />

        {/* Fallback redirect */}
        <Route path="*" element={<Navigate to="/dashboard" />} />
      </Route>
    </Routes>
  );
}

export default App;
